import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), 'FilterListSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FilterListSharp.js
// module id = 3653
// module chunks = 2